<div>
  <div class="row">
    <!-- periodType -->
    <div
      [class]="config?.responsiveClassName || 'md:tw-w-1/2'"
      [ngClass]="inputClass"
    >
      <custom-select-search
        [label]="config?.periodTypeLabel"
        [items]="smsSentPeriodTypes"
        [control]="config?.periodTypeControl"
        [isDisabled]="config?.isDisableSentDelayType"
        optionTitle="key"
        optionValue="value"
        [removable]="false"
        [(value)]="periodType"
        (valueChange)="onChangePeriodType($event)"
      >
      </custom-select-search>
    </div>

    <!-- periodText -->
    <div
      [class]="config?.responsiveClassName || 'md:tw-w-1/2'"
      [ngClass]="inputClass"
    >
      <form-field
        *ngIf="!isSmartSms || periodType != SmartSmsPeriodType.Minute"
        class="tw-w-full"
        [control]="config?.periodTextControl"
        [label]="config?.periodTextLabel"
        [value]="periodText | numberSeparator"
        (valueChange)="periodText = $event; emitPeriodText($event)"
      >
        <span
          label-content
          translate
          [translateParams]="{ type: periodTypeTextForTitle }"
          >{{ config?.periodTextLabel }}</span
        >
      </form-field>
      <form-field
        *ngIf="isSmartSms && periodType == SmartSmsPeriodType.Minute"
        class="tw-w-full"
        [control]="config?.periodTextControl"
        [label]="config?.periodTextLabel"
        [value]="periodText | numberSeparator"
        [min]="10"
        (valueChange)="periodText = $event; emitPeriodText($event)"
      >
        <span
          label-content
          translate
          [translateParams]="{ type: periodTypeTextForTitle }"
          >{{ config?.periodTextLabel }}</span
        >
      </form-field>
    </div>
  </div>
</div>
